import Grid from "@mui/material/Grid2";
import {Box, TextField, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import {api} from "../../../api/Api";
import {useNavigate} from "react-router-dom";
import {Link as MuiLink} from '@mui/material';
import IconButton from "@mui/material/IconButton";
import toast from "react-hot-toast";

const headers = [
  {label: "Název", size: 5},
  {label: "Odkaz", size: 5},
  {label: "Akce", size: 2},
];

export const Links = ({selectedContract, companyData}) => {
  const navigate = useNavigate();

  const [links, setLinks] = useState([]);


  const fetchLinks = async () => {
    if (!selectedContract || !companyData) {
      return;
    }
    try {
      const response = await api.post(
        `/contract/link/list`,
        {
          companyCode: companyData.report.companyDetail.code,
          contractId: selectedContract.flexiId
        },
      )
      setLinks(response.data.links.map(link => ({ ...link, editing: false })));
    } catch (error) {
      console.error(error);
      if (error.response?.status === 401) navigate("/");
    }
  }

  useEffect(() => {
    fetchLinks();
  }, []);

  const handleAddLink = () => {
    setLinks(prev => [...prev, { name: "", link: "", editing: true }]);
  };

  const handleChange = (index, field, value) => {
    setLinks(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleToggleEdit = async (index) => {
    const link = links[index];

    if (link.editing) {
      await saveLink(link, index);
    } else {
      setLinks(prev => {
        const updated = [...prev];
        updated[index] = { ...updated[index], editing: true };
        return updated;
      });
    }
  };

  const handleDelete = async (index) => {
    const link = links[index];

    if (link.id) {
      try {
        await api.post("/contract/link/delete", {
          companyCode: companyData.report.companyDetail.code,
          linkId: link.id,
        });
        toast.success(`Odkaz byl smazán`);
        setLinks(prev => prev.filter((_, i) => i !== index));
      } catch (error) {
        toast.error(`Odkaz se nepodařilo smazat`);
        console.error("Failed to delete link:", error);
      }
    }
  };

  const saveLink = async (link, index) => {
    const isNew = !link.id;

    const payload = isNew
      ? {
        companyCode: companyData.report.companyDetail.code,
        contractId: selectedContract.flexiId,
        name: link.name,
        link: link.link,
        contentType: "text/html",
      }
      : {
        companyCode: companyData.report.companyDetail.code,
        linkId: link.id,
        name: link.name,
        link: link.link,
        contentType: "text/html",
      };

    const endpoint = isNew ? "/contract/link/create" : "/contract/link/update";

    try {
      const response = await api.post(endpoint, payload);

      toast.success(`Odkaz byl ${isNew ? "vytvořen" : "upraven"}`);

      if (isNew) {
        setLinks(prev => {
          const updated = [...prev];
          updated[index] = { ...link, id: response.data.id, editing: false };
          return updated;
        });
      } else {
        setLinks(prev => {
          const updated = [...prev];
          updated[index] = { ...link, editing: false };
          return updated;
        });
      }

    } catch (error) {
      toast.error(`Odkaz se nepodařilo ${isNew ? "vytvořit" : "upravit"}`);
      console.error("Failed to save link:", error);
    }
  };

  return (
    <Grid container spacing={2} alignItems="center">
      {headers.map((header, index) => (
        <Grid item key={index} size={header.size}>
          <Typography fontWeight="bold">{header.label}</Typography>
        </Grid>
      ))}

      {links.map((file, index) => (
        <React.Fragment key={index}>
          <Grid item size={5}>
            {file.editing ? (
              <TextField
                size="small"
                fullWidth
                value={file.name}
                onChange={(e) => handleChange(index, 'name', e.target.value)}
              />
            ) : (
              <Typography>{file.name}</Typography>
            )}
          </Grid>
          <Grid item size={5}>
            {file.editing ? (
              <TextField
                size="small"
                fullWidth
                value={file.link}
                onChange={(e) => handleChange(index, 'link', e.target.value)}
              />
            ) : (
              <MuiLink
                href={file.link?.startsWith('http') ? file.link : `https://${file.link}`}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                <Typography noWrap>{file.link}</Typography>
              </MuiLink>
            )}
          </Grid>
          <Grid item size={2}>
            <Box display="flex" alignItems="center">
              <IconButton size="small" onClick={() => handleToggleEdit(index)}>
                {file.editing ? <SaveIcon sx={{ color: 'black' }} /> : <EditIcon sx={{ color: 'black' }} />}
              </IconButton>
              <IconButton size="small" sx={{ ml: 1 }} onClick={() => handleDelete(index)}>
                <DeleteIcon sx={{ color: 'black' }} />
              </IconButton>
            </Box>
          </Grid>
        </React.Fragment>
      ))}
      <Grid item size={12}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <IconButton onClick={handleAddLink} size="small">
            <AddIcon sx={{ color: 'black' }} />
          </IconButton>
        </Box>
      </Grid>
    </Grid>
  );
};